const INVITE_CODE_PATTERN = /^invite_[A-Za-z0-9_-]{32}$/;

export function normalizeInviteInput(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";

  try {
    const url = new URL(trimmed);
    const code = url.searchParams.get("invite");
    if (code) return code.trim();
  } catch {
    // A plain invite code is the normal input, so a URL parse failure is fine.
  }

  return trimmed;
}

export function isInviteCode(value: string): boolean {
  return INVITE_CODE_PATTERN.test(value);
}
